import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><defs><style type=\"text/css\"></style></defs><path d=\"M559.63 107.654a67.627 67.627 0 0 0-90.872 0L101.305 456.565a33.898 33.898 0 0 0 45.393 50.351l5.843-5.547V865.53a67.795 67.795 0 0 0 67.796 67.88h197.29V729.307a47.735 47.735 0 0 1 47.756-47.798h92.834a47.735 47.735 0 0 1 47.756 47.798v204.104h201.973a67.795 67.795 0 0 0 67.816-67.88V505.82c15.061 13.627 36.43 12.593 48.959-1.37a33.898 33.898 0 0 0-2.447-47.884L559.63 107.675z\" p-id=\"3816\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home.svg
// module id = 5COo
// module chunks = 29